var map = {
	"./character-1.png": "c2ef",
	"./character-1.svg": "d36c",
	"./character-10.png": "4fb4",
	"./character-10.svg": "ba73",
	"./character-11.png": "8b9d",
	"./character-11.svg": "0f75",
	"./character-12.png": "63a4",
	"./character-12.svg": "7723",
	"./character-13.png": "021b",
	"./character-13.svg": "143d",
	"./character-14.png": "be7f",
	"./character-14.svg": "b2d4",
	"./character-2.png": "b0ae",
	"./character-2.svg": "9e62",
	"./character-3.png": "cc14",
	"./character-3.svg": "9fea",
	"./character-4.png": "a25c",
	"./character-4.svg": "9f0f",
	"./character-5.png": "0687",
	"./character-5.svg": "af02",
	"./character-6.png": "36ff",
	"./character-6.svg": "7557",
	"./character-7.png": "a25f",
	"./character-7.svg": "f2e3",
	"./character-8.png": "03c6",
	"./character-8.svg": "f44a",
	"./character-9.png": "0e1f",
	"./character-9.svg": "037a",
	"./end-decor.png": "7c75",
	"./end.svg": "da61",
	"./face-blue.svg": "9b84",
	"./face-green.svg": "9589",
	"./face-pink.svg": "6cb3",
	"./face-purple.svg": "34ae",
	"./face-yellow.svg": "f877",
	"./number-1.svg": "7565",
	"./number-10.svg": "1f56",
	"./number-2.svg": "f633",
	"./number-3.svg": "eea8",
	"./number-4.svg": "a4a3",
	"./number-5.svg": "b2e0",
	"./number-6.svg": "2cc9",
	"./number-7.svg": "68b1",
	"./number-8.svg": "2e22",
	"./number-9.svg": "faa5",
	"./trend-after-1.png": "3b7c",
	"./trend-after-2.png": "8268",
	"./trend-after-3.png": "5848",
	"./trend-after-4.png": "1a1b",
	"./trend-before-1.png": "1bb4",
	"./trend-before-2.png": "eb31",
	"./trend-before-3.png": "816c",
	"./trend-before-4.png": "e31a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";